import { FC } from "react";

const headerStyle: React.CSSProperties = {
  fontSize: "0.7rem",
  fontWeight: 500,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "var(--bs-secondary-color, #6c757d)",
};

const PriceSheetColumnHeaders: FC = () => (
  <div className="jsd-grid mb-2" style={{ padding: "0 12px" }}>
    <div />
    <div style={headerStyle}>Preferred Nomenclature</div>
    <div style={headerStyle}>Journey Step</div>
    <div style={headerStyle}>Conversion Rule</div>
    <div style={headerStyle}>Dimension</div>
    <div style={headerStyle}>Seq</div>
    <div style={headerStyle}>Price Offset</div>
    <div style={headerStyle}>Date Added</div>
    <div />
  </div>
);

export default PriceSheetColumnHeaders;
